<template>
    <fb-list-body :pager="pager"
                  :showBtnGroup="!devSn"
                  @handlePagerSizeChange="handlePagerSizeChange"
                  @handlePagerIndexChange="handlePagerIndexChange"
    >

        <template slot="btn-group">
            <el-button icon="el-icon-delete" @click.stop="clearLogDialog = true">清空日志</el-button>
        </template>


        <template slot="search-form">


           <template v-if="!devSn">

               <el-form-item class="search-form-item" label="设备SN">
                   <el-input v-model="searchForm.devSn" placeholder="设备SN"></el-input>
               </el-form-item>

               <el-form-item class="search-form-item" label="设备编号">
                   <el-input v-model="searchForm.devNum" placeholder="设备编号"></el-input>
               </el-form-item>
           </template>


            <el-form-item class="search-form-item" label="查询日期">
                <el-date-picker
                        v-model="queryDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>

            <el-button icon="el-icon-search" size="mini" type="primary" @click.stop="handleSearch">查询</el-button>

        </template>

        <template slot="table">

            <el-dialog
                    title="提示"
                    :visible.sync="clearLogDialog"
                    width="30%"
            >

                <el-form label-position="top">
                    <el-form-item label="清除多久以前的日志（天）">
                        <el-input v-model="logDays" placeholder="清除多久以前的日志（天）"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="clearLogDialog = false">取 消</el-button>
                    <el-button type="primary" @click="handleClearLog">确 定</el-button>
                  </span>
            </el-dialog>

            <el-table :data="tableData" @selection-change="handleSelectionChange">

                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>

                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>

                <el-table-column
                        prop="devSn"
                        label="设备SN"
                        width="120"
                >
                </el-table-column>

                <el-table-column
                        prop="devNum"
                        width="80"
                        label="设备编号"
                >

                </el-table-column>

                <el-table-column
                        prop="content"
                        label="通讯内容"

                >
                </el-table-column>


                <el-table-column
                        width="180"
                        prop="createTimeStr"
                        label="创建时间"
                >
                </el-table-column>

                <el-table-column
                        width="100"
                        fixed="right"
                        label="操作"
                >
                    <template slot-scope="scope">
                        <el-link type="danger" @click="handleDelete(scope.row)" :underline="false"
                                 style="margin-left: 10px;">删除
                        </el-link>
                    </template>
                </el-table-column>


            </el-table>
        </template>


    </fb-list-body>
</template>

<script>

    import {Loading} from "element-ui";

    export default {
        name: "SpDevLog",
        components: {},
        props: {
            timestamp: {
                type: Number, default: function () {
                    return new Date().getTime()
                }
            },
            devSn:{
                type:String,
                default:''
            }
        },
        data() {
            return {
                logDays: 30,
                clearLogDialog: false,
                queryDate: '',
                api: {
                    list: this.$api.spDevLog.list,
                    delete: this.$api.spDevLog.delete,
                    batchDelete: this.$api.spDevLog.batchDelete,
                },
                searchForm: {queryStartDate: '', queryEndDate: ''},
                tableData: [],
                selection: [],
                pager: {
                    pageSize: 10
                    , pageIndex: 1,
                    itemCount: 0
                }
            }
        },
        computed: {
            searchParams() {
                return Object.assign({}, this.$route.query, this.searchForm, this.pager);
            }
        },
        watch: {
            queryDate: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.queryDate && this.queryDate.length) {
                        this.searchForm.queryStartDate = this.queryDate[0];
                        this.searchForm.queryEndDate = this.queryDate[1];
                    } else {
                        this.searchForm.queryStartDate = '';
                        this.searchForm.queryEndDate = '';
                    }
                }
            },
            "$route.query": {
                handler() {
                    this.pageIndex = 1;
                    this.handleSearch();
                },
                deep: true,
                immediate: true
            },
            "pager.pageIndex": {
                handler() {
                    this.handleSearch();

                },
                deep: true,
                immediate: true
            },
            "pager.pageSize": {
                handler() {
                    this.handleSearch();

                },
                deep: true
            }
        },
        methods: {
            async handleClearLog() {

                this.clearLogDialog = false;

                await this.$confirm('您现在正在进行日志清空操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                let resp = await this.$http.post(this.$api.spDevLog.clearLog, this.$qs.stringify({logDays: this.logDays}));
                if (resp.data.status === 200) {

                    this.$message({type: 'success', message: resp.data.desc});

                    this.handleSearch();
                } else {
                    this.$message({type: 'error', message: resp.data.desc});

                }


            },

            handleEdit(e) {

                if (e && e.code) {
                    this.$router.push({path: 'edit', query: {code: e.code}});
                    return;
                }

                if (!this.selection.length) {
                    this.$message({type: 'warning', message: '未选择记录'});
                    return;
                }

                if (this.selection.length > 1) {
                    this.$message({type: 'warning', message: '一次只能编辑一条数据'});
                    return;
                }

                this.$router.push({path: 'edit', query: {code: this.selection[0].code}});
            },
            handleDelete(row) {


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.api.delete, vm.$qs.stringify({code: row.code})).then((resp) => {
                        if (resp.data.status === 200) {
                            vm.$message({type: 'success', message: resp.data.desc});
                            vm.handleSearch();
                        } else {
                            vm.$message({type: 'error', message: resp.data.desc});

                        }
                    })


                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },
            handleBatchDelete() {


                let vm = this;

                if (!this.selection.length) {
                    this.$message({type: 'warning', message: '未选择记录'});
                    return;
                }


                let codes = [];

                this.selection.forEach((e) => {
                    codes.push(e.code);
                });


                this.$confirm('您现在正在进行批量删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(this.api.batchDelete, codes).then((resp) => {
                        if (resp.data.status === 200) {
                            vm.$message({type: 'success', message: resp.data.desc});
                            vm.handleSearch();
                        } else {
                            vm.$message({type: 'error', message: resp.data.desc});

                        }
                    })


                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });


            },
            handleSelectionChange(selection) {
                console.log(selection);
                this.selection = selection;
            },
            handlePagerSizeChange(e) {
                this.pager.pageSize = e;
            },
            handlePagerIndexChange(e) {
                this.pager.pageIndex = e;
            },
            handleSearch() {
                let vm = this;
                this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


                    for (let key in resp.data.data) {
                        if (resp.data.data[key] instanceof Array) {
                            vm.tableData = resp.data.data[key];
                        }
                    }

                    //处理分页
                    vm.pager.pageIndex = resp.data.data.pager.pageIndex;
                    vm.pager.pageSize = resp.data.data.pager.pageSize;
                    vm.pager.itemCount = resp.data.data.pager.itemCount;

                })
            },
            handleDownTemplate() {
                window.open(this.$api.quoteBaseData.downloadTemplate);
            }
        },
        created() {
            for (let key in this.searchForm) {
                if (this.$route.query[key]) {
                    this.searchForm[key] = this.$route.query[key];
                }
            }
        }
    }
</script>

<style scoped>

</style>